import { useEffect } from "react"
import PropTypes from "prop-types"

import styles from "../../styles/notifications/NotificationsToast.module.css"
import { Button } from "primereact/button"

//Sounds
import useSound from "use-sound"
import generalNotificationSound from "../../assets/sounds/GeneralNotificationChime.mp3"
import trCall from "../../assets/sounds/notification_telerecovery_call.mp3"

function NotificationsToastContent(props) {
  const icon = props.isError ? "error" : "info"
  let organizationName = ""

  if (props.notification) {
    organizationName = props.getOrganizationName
      ? props.getOrganizationName(props.notification.groupId)
      : "Unknown organization" // Fallback in case notification is not provided
  }

  //Sounds
  const [playGeneralSound, { stop: stopGeneralSound }] = useSound(
    generalNotificationSound,
  )
  const [playTrCall, { stop: stopTrCall, sound }] = useSound(trCall, {
    volume: 0.25,
  })

  const handleCloseClick = (markAsRead) => {
    stopGeneralSound()
    stopTrCall()

    const msg = props.toast.current.state.messages.filter(
      (x) => x.detail === props.toastId,
    )

    if (msg.length > 0) {
      props.toast.current.onClose(msg[0])
    }

    if (markAsRead && !props.systemNotification)
      props.markNotificationRead(props.notificationId)
  }

  useEffect(() => {
    if (props.notification?.eventType && !props.muteSound) {
      switch (props.notification.eventType) {
        case "incoming_call":
          if (sound) {
            sound.loop(true)
            playTrCall()
            return () => stopTrCall()
          }
          break
        default:
          playGeneralSound()
          return () => stopGeneralSound()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, playGeneralSound, playTrCall, sound])

  const actionButton = (label, actionUrl, padLeft) => {
    return (
      <Button
        className={
          styles.actionButton + " p-button-outlined p-button-secondary"
        }
        style={{ marginLeft: padLeft, marginTop: "10px" }}
        label={label}
        onClick={() => {
          props.onHandleActionURL(
            actionUrl,
            props.notification,
            props.notificationId,
          )
          handleCloseClick(false)
        }}
      />
    )
  }

  const buildBody = () => {
    const primary = props.primaryActionLabel || "Primary action"
    const secondary = props.secondaryActionLabel || "Secondary action"

    return (
      <div>
        {props.title && (
          <div className="mb-2">
            <b>{props.title}</b>
          </div>
        )}
        {props.isReactMessage ? (
          props.description
        ) : (
          <div dangerouslySetInnerHTML={{ __html: props.description }} />
        )}
        {(props.primaryActionUrl || props.secondaryActionUrl) && (
          <div style={{ display: "flex" }}>
            {props.primaryActionUrl &&
              actionButton(primary, props.primaryActionUrl)}
            {props.secondaryActionUrl &&
              actionButton(secondary, props.secondaryActionUrl, "10px")}
          </div>
        )}

        {organizationName && (
          <div className={styles.organizationName}>{organizationName}</div>
        )}
      </div>
    )
  }

  function showCloseAndRead() {
    const disableForType = ["incoming_call"]
    return !disableForType.some((type) => type === props.notification.eventType)
  }

  return (
    <div className={styles.gridContainer}>
      <div className={styles.gridItemIcon}>
        <span className="material-icons ">{icon}</span>
      </div>
      <div className={styles.gridItemMain}>{buildBody()}</div>
      <div className={styles.gridItemClose}>
        <span
          className="material-icons  p-overlay-badge"
          style={{ border: "none", background: "none", cursor: "pointer" }}
          onClick={() => {
            handleCloseClick(false)
          }}
        >
          {"close"}
        </span>
      </div>
      {!props.isInfo && !props.systemNotification && showCloseAndRead() ? (
        <div className={styles.gridItemCloseAndRead}>
          <span
            className="material-icons  p-overlay-badge"
            style={{ border: "none", background: "none", cursor: "pointer" }}
            onClick={() => handleCloseClick(true)}
          >
            {"done_all"}
          </span>
        </div>
      ) : null}
    </div>
  )
}

NotificationsToastContent.propTypes = {
  toast: PropTypes.instanceOf(Object),
  notification: PropTypes.instanceOf(Object),
  systemNotification: PropTypes.bool,
  isError: PropTypes.bool,
  toastId: PropTypes.number,
  notificationId: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isReactMessage: PropTypes.bool,
  primaryActionUrl: PropTypes.string,
  primaryActionLabel: PropTypes.string,
  secondaryActionUrl: PropTypes.string,
  secondaryActionLabel: PropTypes.string,
  onHandleActionURL: PropTypes.func,
  muteSound: PropTypes.bool,
}

export default NotificationsToastContent
